// extracted by mini-css-extract-plugin
export default {"Promotions":"Promotion_Promotions__KgQS-","Prmotion":"Promotion_Prmotion__5PyOB","Icon":"Promotion_Icon__tWWKM","Parag":"Promotion_Parag__sl3zT"};